import { useQuery } from '@tanstack/react-query';
import { Users } from 'lucide-react';
import { Avatar } from '@vd/ui';
import { api } from '../../lib/api';
import { When } from '../../lib/When';
import { Card } from '../dashboard/DashboardCard';
import styles from '../dashboard/DashboardSections.module.css';

/**
 * Who logged what this month, on Reports' Team page (t-x2GtEg: it was the
 * Dashboard's Your team, which gave its place to Agent activity). Everyone,
 * the most tickets first, each with their share and when they were last
 * active. This calendar month whatever the range above, which the note says.
 * An owner's: the server answers no one else.
 */
export function TeamThisMonth({ companyId }: { companyId: string }) {
  const { data } = useQuery({ queryKey: ['dashboard', companyId, 'team'], queryFn: () => api.dashboard.team(companyId) });
  if (!data || data.members.length === 0) return null;
  const total = data.members.reduce((sum, member) => sum + member.ticketsThisMonth, 0);
  const members = [...data.members].sort((a, b) => b.ticketsThisMonth - a.ticketsThisMonth);
  return (
    <Card title="This month by person" testId="report-team-month" icon={Users} tone="blue" size="full">
      <p className={styles.note}>Tickets each person logged this calendar month, whatever the range above, of {total} in all.</p>
      <ul className={styles.rows}>
        {members.map((member) => {
          const share = total > 0 ? member.ticketsThisMonth / total : 0;
          return (
            <li key={member.userId} className={styles.member}>
              {/* The colours the board gives this person. */}
              <Avatar name={member.name} size="sm" />
              <span className={styles.rowTitle}>{member.name}</span>
              <span className={styles.rowMeta}>
                {member.ticketsThisMonth} · {Math.round(share * 100)}% · {member.lastActiveAt ? <When at={member.lastActiveAt} prefix="active " /> : 'not seen yet'}
              </span>
              <span className={styles.bar} aria-hidden><span style={{ width: `${Math.round(share * 100)}%` }} /></span>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
